// import { dictionary } from "../dictionary";

import { dictionary } from "../dictionaries";

export const translateKey = (key:string, lang:string) => {
	const phrase = dictionary[key];
	if(!phrase){ return key; }
	return phrase[lang as ("en"|"is")] || `${key}.${lang}`;
};